import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getSearchFilters = (state: ContentPluginRootState) => state.data.results?.search.filters || {};

export default getSearchFilters;
